import { CompositeLayer } from '@deck.gl/core';
import { PathLayer } from '@deck.gl/layers';

import { Position } from '../../../types/Geometry';

interface DronePathLayerProps {
  dronePath: Position[];
}

class DronePathLayer extends CompositeLayer<DronePathLayerProps> {
  renderLayers() {
    const dronePathLayer = new PathLayer({
      id: 'drone-path-layer',
      data: [
        {
          path: this.props.dronePath.map((p) => [p.longitude, p.latitude])
        }
      ],
      getPath: (d: any) => d.path,
      getColor: () => [255, 255, 0],
      getWidth: 2,
      pickable: true
    });

    return [dronePathLayer];
  }
}

export default DronePathLayer;
